var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95674 15.9624H12.2876C12.8364 15.9624 13.2819 15.5169 13.2819 14.9681V2.03759V0.994361C13.2819 0.445489 12.8364 0 12.2876 0H6.95674H5.18418V0.328947C5.18792 0.362782 5.18982 0.398496 5.18982 0.434211V2.6015V3.15789C5.18982 3.93045 4.562 4.55827 3.78944 4.55827H3.23305H1.06575C1.03756 4.55827 1.00748 4.55639 0.979288 4.55451H0.633423V14.9681C0.633423 15.5169 1.07891 15.9624 1.62778 15.9624H2.71801H6.95674ZM7.15787 12.5827H3.6823C3.4229 12.5827 3.21237 12.3722 3.21237 12.1128C3.21237 11.8534 3.4229 11.6429 3.6823 11.6429H7.15975C7.41914 11.6429 7.62967 11.8534 7.62967 12.1128C7.62967 12.3722 7.41726 12.5827 7.15787 12.5827ZM10.6353 10.1842H3.6823C3.4229 10.1842 3.21237 9.97369 3.21237 9.71431C3.21237 9.45489 3.4229 9.24438 3.6823 9.24438H10.6353C10.8947 9.24438 11.1052 9.45489 11.1052 9.71431C11.1052 9.97369 10.8947 10.1842 10.6353 10.1842ZM3.6823 6.69737H10.6353C10.8947 6.69737 11.1052 6.90789 11.1052 7.16729C11.1052 7.42669 10.8947 7.63722 10.6353 7.63722H3.6823C3.4229 7.63722 3.21237 7.42669 3.21237 7.16729C3.21237 6.90789 3.4229 6.69737 3.6823 6.69737Z",
    fill: "#2D3859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "3e44db8b200023ec91df3436eff2efa4.svg";
export { ForwardRef as ReactComponent };